import { GetCollaboratorsHistoryApprovalFlowResponse } from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryApprovalService = {
  async getApprovalStatusAllSection(
    collaboratorId: number,
  ): Promise<GetCollaboratorsHistoryApprovalFlowResponse> {
    const response =
      await httpClient.get<GetCollaboratorsHistoryApprovalFlowResponse>(
        `v1/collaborators/${collaboratorId}/history/approval-flow/stats`,
      );
    return response;
  },
  async submitDrafItemsToCM(collaboratorId: number): Promise<void> {
    await httpClient.post(
      `v1/collaborators/${collaboratorId}/history/approval-flow/submit-to-cm`,
    );
  },
  async approveAllPendingItems(collaboratorId: number): Promise<void> {
    await httpClient.post(
      `v1/collaborators/${collaboratorId}/history/approval-flow/confirm`,
    );
  },
};

export default CollaboratorsHistoryApprovalService;
